import {inject} from "mobx-react";
import {Link} from "react-router-dom";
import {useRef, useState} from "react";

const Categories = (props) => {

    const nav = useRef(null);
    const [getState, setState] = useState(false);

    const hidden = (e) => {

        setState(true);

        setTimeout(() => {
            setState(false);
        }, 500);

    }

    return (
        <nav className={"nav"}  ref={nav}>
            <ul className={`flex h3 bb`}>
                {
                    props.Settings.item.categories && props.Settings.item.categories.hierarchical.map((item, key) => (
                        <li className={`px--3 py--6 ${item.childs ? `nav--have-child` : ``} `} key={`category-${key}`} style={{pointerEvents: getState ? `none` : `all`}}>
                            <Link to={`/${item.slug}`} title={item.name} onClick={() => hidden()}>{item.name}</Link>
                            {
                                item.childs &&
                                <div className={`nav__child`}>
                                    {item.childs.map((parent, key_parent) => (
                                        <div key={`category-parent-${key_parent}`}>
                                            <h2 className={`nav__child-title`}>{parent.name}</h2>
                                            {parent.childs &&
                                            <nav className={`flex flex--column list list--no-border py--3`}>
                                                {parent.childs.map((child, key_child) =>
                                                    <Link className={"list__link flex flex--middle mb--2"}
                                                          onClick={() => hidden()} to={`/produkt/${child.slug}`}
                                                          title={child.name}
                                                          key={`category-child-${key_child}`}>{child.name}</Link>
                                                )}
                                            </nav>
                                            }
                                        </div>
                                    ))
                                    }
                                </div>
                            }
                        </li>
                    ))
                }
                <li className={"px--3 py--6 nav--have-child"}>
                    <span style={{cursor: "pointer"}}>Dokumenty</span>
                    <div className={`nav__child`}>
                        <div key={`category-parent-documents`}>
                            <nav className={`flex flex--column list list--no-border py--3`}>
                                <a className="list__link flex flex--middle mb--2" href={"https://bsolawa-mojedokumenty.sgb.pl/dokumenty-publiczne"} target={"_blank"} rel={'nofollow'}>Dokumenty Publiczne</a>
                                <a className="list__link flex flex--middle mb--2" href={"https://bsolawa-mojedokumenty.sgb.pl/"} target={"_blank"} rel={'nofollow'}>Dokumenty Prywatne</a>
                            </nav>
                        </div>
                    </div>
                </li>
                <li className={"px--3 py--6"}>
                    <Link to={`/komunikaty`} title="Ważne komunikaty">Ważne komunikaty</Link>
                </li>
            </ul>
        </nav>)

}

export default inject('Settings')(Categories)
